<template>
  <div class="agent-center container" ref="containerBox" @scroll="handleScroll">
    <!-- 导航栏 -->
    <div ref="stickyBox" :class="[{ sticky: isSticky }, { box: !isSticky }]"
      :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky" :scrollToTop="scrollToTop"></titlePage>
    </div>

    <!-- 主要内容 -->
    <main class="main-content">
      <div class="content-wrapper">
        <!-- 标签切换 -->
        <div class="tabs">
          <div class="tab " @click="tabClick(1)" :class="hover == 1 ? 'active' : ''">我的团队</div>
          <div class="tab" @click="tabClick(2)" :class="hover == 2 ? 'active' : ''">团队佣金</div>
        </div>

        <!-- 团队表格 -->
        <div class="team-table" v-if="hover == 1">
          <table>
            <thead>
              <tr>
                <th>姓名</th>
                <th>手机号</th>
                <th>绑定时间</th>
                <th>团队级别</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td>{{ item.nickname }}</td>
                <td>{{ item.tel }}</td>
                <td>{{ item.reg_time }}</td>
                <td>{{ item.level==1?'一级':'二级' }}</td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="team-table" v-if="hover == 2">
          <table>
            <thead>
              <tr>
                <th>结算人</th>
                <th>公司名称</th>
                <th>职位名称</th>
                <th>结算时间</th>
                <th>结算单号</th>
                <th>结算人次</th>
                <th>结算金额</th>
                <th>佣金收入(元)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td>{{ item.settler_name }}
                  <span class="dengji" :class="item.referral_level==1?'color1':'color2'">{{ item.referral_level==1?'一级':'二级' }}</span>
                </td>
                <td>{{ item.company_name }}</td>
                <td>{{ item.position_name }}</td>
                <td>{{ item.settle_time }}</td>
                <td @click="getDetails(item)" style="color:#0092FF;  cursor: pointer;">{{ item.order_sn }}</td>
                <td>{{ item.settle_people }}</td>
                <td>{{ item.settle_amount }}</td>
                <td style="color:#0092FF">{{ item.commission }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- 页脚 -->
    <fotterVue></fotterVue>
  </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue';
import fotterVue from '@/components/fotter.vue';
export default {
  name: 'AgentCenter',
  components: {
    titlePage,
    fotterVue
  },
  data() {
    return {
      isSticky: false,
      stickyBoxTop: 0,
      isStatus: true,
      hover: 1,
      list: [
    
      ],
     
      searchForm: {
        level: 0,
        page: 1,
        page_size: 10,
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 这里可以添加需要的方法
    tabClick(e) {
      this.hover = e
      this.list=[]
      this.searchForm.level=0
      this.searchForm.page=1
      if(this.hover==1){
this.getList()
      }else{
      this.getList2()
      }
    },
    getDetails(item) {
      this.$router.push({
        path: '/AgentDetails', query: {
          id: item.id
        }
      })
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop;
      const bottomOfWindow = this.$refs.containerBox.scrollHeight - this.$refs.containerBox.scrollTop - this.$refs.containerBox.clientHeight
      // console.log(bottomOfWindow);
      if (this.isStatus == true && bottomOfWindow <= 50) {
        this.searchForm.page += 1
        this.isStatus = false
        if(this.hover==1){
          this.getList()
        }else{
          this.getList2()
        }
      }
    },
    getList() {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.getMyReferrals(this.searchForm).then(res => {
        console.log(res, '666');
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          this.isStatus = res.data.total > this.list.length ? true : false
        }
      })
    },
    getList2 () {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.teamCommissionList(this.searchForm).then(res => {
        console.log(res, '666');
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          this.isStatus = res.data.total > this.list.length ? true : false
        }
      })
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0;
    },
  },
  created() {
    // 组件创建时的逻辑
  },
  mounted() {
    // 组件挂载时的逻辑
    this.scrollToTop()
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
.agent-center {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 导航栏样式 */


/* 主要内容样式 */
.main-content {
  flex: 1;
  background-color: #f6f8fe;

  padding: 40px 0;
  margin-top: 60px;
}

.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 标签样式 */
.tabs {
  display: flex;
  margin-bottom: 20px;
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
}

.tab {
  flex: 1;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: all 0.3s;
}

.tab.active {
  background-color: #0066cc;
  color: white;
}

/* 表格样式 */
.team-table {
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.dengji {
  // width: 36px;
  padding: 0 10px;
  height: 16px;
  background: #FA960F;
  border-radius: 4px;
  text-align: center;
  line-height: 16px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}
.color1{
    background: #FA960F;
}
.color2{
  background-color: #FF6232;
}
.team-table table {
  width: 100%;
  border-collapse: collapse;
}

.team-table th,
.team-table td {
  padding: 15px;
  text-align: center;
  font-size: 14px;
}

.team-table th {
  background-color: #E0F2FF;
  color: #666666;
  font-weight: 500;
}

.team-table td {
  color: #333333;
  border-bottom: 1px solid #f0f0f0;
}

.team-table tr:last-child td {
  border-bottom: none;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 15px;
  }

  .nav {
    display: none;
  }

  .content-wrapper {
    padding: 0 15px;
  }

  .main-content {
    padding: 20px 0;
  }

  .footer-content {
    padding: 0 15px;
    flex-direction: column;
    gap: 30px;
  }

  .footer-middle {
    gap: 30px;
    justify-content: space-between;
  }

  .team-table th,
  .team-table td {
    padding: 12px 8px;
    font-size: 12px;
  }

  .footer-bottom {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .footer-middle {
    flex-direction: column;
    gap: 20px;
  }

  .team-table {
    overflow-x: auto;
  }

  .team-table table {
    min-width: 400px;
  }
}
</style>